import React, { useEffect, useState, useRef } from "react";
import CipHeader from "./CipHeader";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useSelector } from "react-redux";
import cogoToast from "cogo-toast";
import formsService from "../services/forms-service";
import PDFViewer from 'pdf-viewer-reactjs';
import { selectExpForm } from "../state/reducers/formsResultSlice";
import Loader from "react-loader-spinner";
const ExpirationPage = ({ history }) => {
  const [pdfDataResp, setPdfData] = useState();
  const { expFormDetails } = useSelector(selectExpForm);
  const [loading, setLoading] = useState(false);
  const btnRef = useRef();
  const onSubmit1 = async (data) => {
    if (btnRef.current) {
      btnRef.current.setAttribute("disabled", "disabled");
    }
    try {
      let params = {
        begin: expFormDetails.begin,
        close: expFormDetails.close,
        regions: expFormDetails.regions,
        kop: expFormDetails.kop,
        pageBreak: expFormDetails.pageBreak,
        publish: true,
      };
      setLoading(true);
      let resp = await formsService.getExprationPdf(params);
      setLoading(false);
      if (resp) {
        if (resp.code && resp.code !== 200) {
          const { hide } = cogoToast.error(
            "Error generating expiration report. Please try after sometime.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        } else {
          const { hide } = cogoToast.success("Mail Sent Successfully ", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
        }
      } else {
        const { hide } = cogoToast.error(
          "Error generating expiration report. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
      await history.push("/expirationReport");
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error generating expiration report. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const getDetails = async () => {
    try {
      let params = {
        begin: expFormDetails.begin,
        close: expFormDetails.close,
        regions: expFormDetails.regions,
        kop: expFormDetails.kop,
        pageBreak: expFormDetails.pageBreak,
        publish: false,
      };
      let resp = await formsService.getExprationPdf(params);
      if (resp) {
        setPdfData(resp);
      } else {
        const { hide } = cogoToast.error(
          "Error generating expiration report. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error generating expiration report. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  useEffect(() => {
    getDetails();
  }, []);
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">SCRIPT EXPIRATION REPORT</span>
          </div>
        </div>
        <div className="p-2 text-xs">
          <form>
            <ul className="text-right">
              <li className="inline-block text-sm leading-8 w-1/4">
                <button
                  type="button"
                  onClick={() => {
                    onSubmit1();
                  }}
                  ref={btnRef}
                  className="bg-header_bg rounded py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
                  aria-label="submit"
                  data-tag="scanClose"
                >
                  PUBLISH
                </button>
              </li>
            </ul>
          </form>
          <div>
            {pdfDataResp ? 
            <PDFViewer
              document={{
                base64:pdfDataResp
              }}
              showThumbnail={{
                scale:2
              }}
            />
            :""}
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(ExpirationPage)
);
